import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Container, Row, Col, Form, FormGroup, Input, Label, Card, CardBody } from "reactstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { Spinner } from "../../AbstractElements";
import { useParams } from "react-router-dom";


const VerifyOTP = () => {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const location = useLocation();
  const [loader, setLoader] = useState(false);
  const Data = [
    {
      id: 2,
      heading: "Loader 3",
      spinnerClass: "loader-3",
    },
  ];
  const navigate = useNavigate();
  const { method, value, userId } = location.state || {};
  const handleOTPChange = (index, e) => {
    const value = e.target.value;
    if (value === "" && e.nativeEvent.inputType === "deleteContentBackward") {
      const prevInput = document.getElementById(`otp-${index - 1}`);
      if (prevInput) {
        prevInput.focus();
      }
    } else if (value.length === 1 && index < 3) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      if (nextInput) {
        nextInput.focus();
      }
    }
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
  };

  const handlePaste = (e) => {
    const pasteData = e.clipboardData.getData("text");
    const otpValues = pasteData.split("").filter((char) => !isNaN(parseInt(char)));
    document.querySelectorAll('.opt-text').forEach((input, index) => {
      if (otpValues[index]) {
        input.value = otpValues[index];
        handleOTPChange(index, { target: { value: otpValues[index] } });
      }
    });
    e.preventDefault();
  };
  const params = new URLSearchParams(location.search);

  const email = params.get("email"); 
  console.log("🚀 ~ VerifyOTP ~ email:", email)
  const handleVerifyOTP = (e) => {
    e.preventDefault();
    setLoader(true);

    axios.post(`${process.env.REACT_APP_API_BASE_URL}/users/matchOTP`, { email, otp: otp.join('') })
      .then(response => {
      console.log("🚀 ~ handleVerifyOTP ~ response:", response)

        if (response.status===200) {
          toast.success(response.data.message);

          setLoader(false);

          navigate(`/reset-new-password?email=${email}`, { state: {userId }} );
        }
      })
      .catch(error => {
        toast.error("Wrong or expired otp!..");
        setLoader(false);
      });
  };

  return (
    <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
      <Row className="w-100 justify-content-center">
        <Col md="6" lg="4">
          <Card className="mb-4" style={{ height: "400px" }}> {/* Increase card height */}
            <CardBody>
              <div className="login-main">
                <Link to="/forgot-password" className="btn btn-link position-absolute" style={{ font: "12px", top: "10px", left: "10px", color: "black", fontWeight: "bold", textDecoration: "none" }}>
                  &larr; Enter OTP
                </Link>

                <Form className="theme-form login-form">
                  <FormGroup>
                    <Label style={{ color: "grey", margin: "40px 0px 60px" }}>
                      Enter verification code sent to your entered.
                      {/* {method}. */}
                    </Label>
                    <Row className="justify-content-center">
                      {[0, 1, 2, 3].map((index) => (
                        <Col key={index} xs="3" className="p-1">
                          <Input
                            id={`otp-${index}`}
                            className="form-control text-center opt-text"
                            type="text"
                            maxLength="1"
                            onChange={(e) => handleOTPChange(index, e)}
                            onPaste={handlePaste}
                            style={{
                              borderRadius: "50%",
                              width: "50px",
                              height: "50px",
                              backgroundColor: "#ede6e6",
                              textAlign: "center",
                              fontSize: "20px",
                            }}
                          />
                        </Col>
                      ))}
                    </Row>
                  </FormGroup>
                  {loader && (
                    <div className="loader-box">
                      <Spinner
                        attrSpinner={{ className: Data[0].spinnerClass }}
                      />
                    </div>
                  )}
                  <button
                    className="btn btn-custom w-100 mt-5"
                    onClick={handleVerifyOTP}
                    style={{
                      backgroundColor: "#000",
                      borderRadius: "18px",
                      border: "none",
                      color: "#fff",
                      padding: "10px 20px",
                      marginTop: "40px  !important" // Adjust marginTop here to move the button down
                    }}
                  >
                    Verify
                  </button>
                </Form>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default VerifyOTP;
